import type {
  ChannelAccountStatus,
  ChannelsOverview,
  ChatChannel,
} from "../services/chatbotV2/chatbotV2Service";

export const normalizeChannelList = (
  channels: ChannelsOverview["channels"] | undefined
): ChannelAccountStatus[] => {
  if (!channels) return [];
  if (Array.isArray(channels)) return channels;
  return Object.values(channels);
};

export const normalizeChannelsMap = (
  channels: ChannelsOverview["channels"] | undefined
): Record<string, ChannelAccountStatus> => {
  const map: Record<string, ChannelAccountStatus> = {};
  normalizeChannelList(channels).forEach((channel) => {
    map[String(channel.channel)] = channel;
  });
  return map;
};

export const getChannelStatus = (
  overview: ChannelsOverview | null | undefined,
  channel: ChatChannel | string
): ChannelAccountStatus | null => {
  return normalizeChannelsMap(overview?.channels)[String(channel)] ?? null;
};

export const isChannelConnected = (status?: ChannelAccountStatus | null): boolean =>
  Boolean(status?.exists && status?.is_active && status?.status === "connected");
